import type { IFrontendServiceContainer } from '@phi/frontend/service-container';
import type { Route } from '@phi/vue-router';
import { type PropType, defineComponent, h, shallowRef, ref } from 'vue';
import { type FormData, RegisterForm } from '../../components/register-form';
import { LoginPage } from '../login-page';
import { open_onshape_oauth_page } from '../../onshape';
import { Desktop } from './desktop';
import { Mobile } from './mobile';

export const RegisterPage = defineComponent({
    name: 'RegisterPage',

    props: {
        app: {
            required: true,
            type: Object as PropType<IFrontendServiceContainer>,
        },

        route: {
            required: true,
            type: Function as PropType<Route>,
        },
    },

    setup({ app, route }) {
        const util = app.util;
        const sending = ref(false);
        const auth = app.authentication;
        const error = shallowRef(undefined as undefined | Error);
        const pop_under = app.pop_under_with_router;
        const state = app.state;

        async function on_register(form: FormData) {
            if (sending.value) return;
            sending.value = true;
            const session_id = await auth.sign_up(form.email, form.password, form.newsletter);
            if (session_id instanceof Error) {
                error.value = session_id;
                sending.value = false;
                return;
            }
            await auth.authenticate_through_phi(session_id);
            sending.value = false;
            return;
        }

        function on_onshape() {
            pop_under.hide_pop_under();
            state.spinner = 'Please wait...';
            open_onshape_oauth_page();
        }

        const Form = () => h(RegisterForm, {
            error: error.value,
            light: util.dark_mode_enabled(),
            onLogin: () => route(() => h(LoginPage, { app, route })),
            onOnshape: on_onshape,
            onRegister: on_register,
            disabled: sending.value,
            note: sending.value ? 'Processing registration...' : undefined,
        });

        return () => [
            Desktop(app.util.dark_mode_enabled(), Form),
            Mobile(app.util.dark_mode_enabled(), Form),
        ];
    },
});
